import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import "../../../styles/Auth/campaign.css";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import sendIcon from '@iconify/icons-mdi/arrow-top-right-bold-box-outline';
import { DateTime } from "luxon";
import { getData, postData, uploadFile, putData, deleteData } from "../../../webService/webservice.js";
const CampaignPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isAddCampaign, setIsAddCampaign] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [refreshKey, setRefreshKey] = useState(0);
    const [campaigns, setCamapigns] = useState([]);
    const [open, setOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const sessionToken = sessionStorage.getItem("sessionToken");
    const [stores, setStores] = useState([]);
    const [limit, setLimit] = useState(5);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editCampaignId, setEditCampaignId] = useState(null);
    const [CampaignsToDelete, setCampaignsToDelete] = useState(null);
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'SL',
        'Name',
        'Campaign Type',
        'Start Date',
        'End Date',
        'Status',
        'Action',
    ];
    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };
    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };
    const [formData, setFormData] = useState({
        campaignName: "",
        campaignType: "",
        description: "",
        campaignAssets: [
            { assetType: "", url: "", file: "", localFile: null, description: "" }
        ],
        startDate: "",
        endDate: "",
        status: ""
    });

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleAssetChange = (index, field, value) => {
        setFormData((prev) => {
            const updatedAssets = [...prev.campaignAssets];

            // If user picks a file, reset url until uploaded
            if (field === "file") {
                updatedAssets[index].file = value;   // File object before upload
                updatedAssets[index].url = "";       // Clear old URL
            } else {
                updatedAssets[index][field] = value;
            }

            return { ...prev, campaignAssets: updatedAssets };
        });
    };

    const addAsset = () => {
        setFormData((prev) => ({
            ...prev,
            campaignAssets: [
                ...prev.campaignAssets,
                { assetType: "", url: "", file: "", localFile: null, description: "" }
            ]
        }));
    };

    const removeAsset = (index) => {
        setFormData((prev) => {
            const updatedAssets = [...prev.campaignAssets];
            updatedAssets.splice(index, 1);
            return { ...prev, campaignAssets: updatedAssets };
        });
    };

    const handleAddCampaign = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem("sessionToken");
            const userId = sessionStorage.getItem("userId");

            let uploadedAssets = [];

            for (const asset of formData.campaignAssets) {
                if (asset.assetType === "Link") {
                    uploadedAssets.push({
                        assetType: asset.assetType,
                        file: "",
                        url: asset.url,
                        description: asset.description,
                    });
                } else if (asset.file && userId) {
                    const uploadResult = await uploadFile(`files/upload/${userId}`, asset.file);

                    // ✅ Handle API response (either inside .data or top-level)
                    const fileInfo = uploadResult.data ? uploadResult.data : uploadResult;

                    if (uploadResult?.status === 200 && fileInfo.filename && fileInfo.uri) {
                        uploadedAssets.push({
                            assetType: asset.assetType,
                            file: fileInfo.filename,
                            url: fileInfo.uri,
                            description: asset.description,
                        });
                    } else {
                        toast.error(uploadResult?.message || "File upload failed");
                        return; // ❌ Stop campaign creation
                    }
                } else {
                    toast.error(`Missing file for asset type: ${asset.assetType}`);
                    return;
                }
            }

            // ✅ Only create campaign if uploads succeed
            const campaignData = {
                campaignName: formData.campaignName,
                campaignType: formData.campaignType,
                description: formData.description,
                campaignAssets: uploadedAssets,
                startDate: formData.startDate,
                endDate: formData.endDate,
                status: formData.status,
            };

            console.log("📦 Sending campaign data:", campaignData);

            const response = await postData("campaigns/", campaignData, token);

            toast.success(response.message || "Campaign added successfully");

            // 🔄 Reset form
            setFormData({
                campaignName: "",
                campaignType: "",
                description: "",
                campaignAssets: [{ assetType: "", url: "", file: null, description: "" }],
                startDate: "",
                endDate: "",
                status: "",
            });
            setIsAddCampaign(false);
            navigate("/campaigns");
            triggerRefresh();
        } catch (error) {
            console.error("Add Campaign Error:", error);
            toast.error(error.message || "Add Campaign Failed");
        }
    };

    useEffect(() => {
        const token = sessionStorage.getItem("Token");
        fetchCampaigns(currentPage, limit, searchQuery, token);
    }, [currentPage, limit, refreshKey, searchQuery]);

    const fetchCampaigns = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit,
            title: searchQuery?.trim() || ""
        }
        try {
            setLoading(true);
            const response = await getData('campaigns/campaigns', params, sessionToken); // Your API route
            const resultsWrapper = response?.data?.[0];
            const campaignList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setCamapigns(campaignList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch categories");
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateCampaign = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem("sessionToken");
            const userId = sessionStorage.getItem("userId");

            let updatedAssets = [];

            for (const asset of formData.campaignAssets) {
                if (asset.assetType === "Link") {
                    // Links are stored directly
                    updatedAssets.push({
                        assetType: asset.assetType,
                        file: "",
                        url: asset.url,
                        description: asset.description,
                        ...(asset._id && { _id: asset._id }) // keep existing ID if present
                    });
                }
                else if (asset.localFile && userId) {
                    // New file selected → upload first
                    const uploadResult = await uploadFile(`files/upload/${userId}`, asset.localFile);

                    const fileInfo = uploadResult.data ? uploadResult.data : uploadResult;

                    if (uploadResult?.status === 200 && fileInfo.filename && fileInfo.uri) {
                        updatedAssets.push({
                            assetType: asset.assetType,
                            file: fileInfo.filename,
                            url: fileInfo.uri,
                            description: asset.description,
                            ...(asset._id && { _id: asset._id }) // if updating existing asset
                        });
                    } else {
                        toast.error(uploadResult?.message || "File upload failed");
                        return;
                    }
                }
                else {
                    // Keep existing file as-is (not replaced)
                    updatedAssets.push({
                        assetType: asset.assetType,
                        file: asset.file || "",
                        url: asset.url || "",
                        description: asset.description,
                        ...(asset._id && { _id: asset._id })
                    });
                }
            }

            // ✅ Build update payload
            const campaignData = {
                campaignName: formData.campaignName,
                campaignType: formData.campaignType,
                description: formData.description,
                campaignAssets: updatedAssets,
                startDate: formData.startDate,
                endDate: formData.endDate,
                status: formData.status,
            };

            console.log("📦 Updating campaign:", campaignData);

            const response = await putData(`campaigns/campaign/${editCampaignId}`, campaignData, token);

            toast.success(response.message || "Campaign updated successfully");
            setIsPopupMode(false);
            setIsEditMode(false);
            fetchCampaigns(currentPage, limit);
            navigate("/campaigns");
            triggerRefresh();
        } catch (error) {
            console.error("Update Campaign Error:", error);
            toast.error(error.message || "Update Campaign Failed");
        }
    };

    const handleOpen = (campaignId) => {
        setCampaignsToDelete(campaignId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCampaignsToDelete(null);
    };

    const handleDeleteCampaign = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem('sessionToken');
            const response = await deleteData(`campaigns/campaign/${CampaignsToDelete}`, token);
            toast.success(response.message || "Campaign deleted successfully");
            setCampaignsToDelete(null);
            fetchCampaigns(currentPage, limit);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete Campaign");
        }
    }

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    return (
        <div className="campaign-layout">
            <div className="campaign-content">
                <main className="campaign-main">
                    {isAddCampaign ? (
                        <div className="add-Campaign-form">
                            <h3>Add Campaign</h3>
                            <form className="Campaign-form">
                                <div className="Campaign-form-row">
                                    <div className="Campaign-form-group">
                                        <label htmlFor="campaignName" className="input-label">
                                            Campaign Name
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Campaign name"
                                            required
                                            className="Campaign-input"
                                            value={formData.campaignName}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, campaignName: e.target.value }))
                                            }
                                        />
                                    </div>
                                    <div className="Campaign-form-group">
                                        <label className="input-label">Campaign Type</label>
                                        <select
                                            id="campaignType"
                                            className="Campaign-input"
                                            required
                                            disabled={!formData.campaignName}
                                            value={formData.campaignType}
                                            onChange={(e) => {
                                                const selectedcampaignType = e.target.value;
                                                setFormData((prev) => ({ ...prev, campaignType: selectedcampaignType }))
                                            }}
                                        >
                                            <option value='' >Select Campaign Type</option>
                                            <option value='Email'>Email</option>
                                            <option value='WhatsApp'>WhatsApp</option>
                                            <option value='SMS'>SMS</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="Campaign-form-row-campaignAsets">
                                    <label className="input-label">Campaign Assets</label>

                                    {formData.campaignAssets.map((asset, index) => (
                                        <div key={index} className="asset-block">
                                            {/* Asset Type */}
                                            <select
                                                value={asset.assetType}
                                                onChange={(e) =>
                                                    handleAssetChange(index, "assetType", e.target.value)
                                                }
                                            >
                                                <option value="">Select Asset Type</option>
                                                <option value="Image">Image</option>
                                                <option value="Video">Video</option>
                                                <option value="PDF">PDF</option>
                                                <option value="Link">Link</option>
                                                <option value="Other">Other</option>
                                            </select>

                                            {/* URL or File */}
                                            {asset.assetType === "Link" ? (
                                                <input
                                                    type="url"
                                                    placeholder="Enter URL"
                                                    value={asset.url || ""}
                                                    onChange={(e) =>
                                                        handleAssetChange(index, "url", e.target.value)
                                                    }
                                                />
                                            ) : asset.assetType === "Image" ||
                                                asset.assetType === "Video" ||
                                                asset.assetType === "PDF" ? (
                                                <>
                                                    {asset.file && (
                                                        <a href={asset.url} target="_blank" rel="noreferrer">
                                                            View Uploaded {asset.assetType}
                                                        </a>
                                                    )}
                                                    <input
                                                        type="file"
                                                        accept={
                                                            asset.assetType === "Image"
                                                                ? "image/*"
                                                                : asset.assetType === "Video"
                                                                    ? "video/*"
                                                                    : ".pdf"
                                                        }
                                                        onChange={(e) =>
                                                            handleAssetChange(index, "file", e.target.files[0])
                                                        }
                                                    />
                                                </>
                                            ) : (
                                                <input
                                                    type="text"
                                                    placeholder="Enter Asset Info"
                                                    value={asset.url || ""}
                                                    onChange={(e) =>
                                                        handleAssetChange(index, "url", e.target.value)
                                                    }
                                                />
                                            )}

                                            {/* Description */}
                                            <input
                                                type="text"
                                                placeholder="Description"
                                                value={asset.description || ""}
                                                onChange={(e) =>
                                                    handleAssetChange(index, "description", e.target.value)
                                                }
                                            />

                                            {/* Remove Button */}
                                            {formData.campaignAssets.length > 1 && (
                                                <button type="button" onClick={() => removeAsset(index)}>
                                                    Remove
                                                </button>
                                            )}
                                        </div>
                                    ))}

                                    <button type="button" className="add-asset-btn" onClick={addAsset}>
                                        Add
                                    </button>

                                </div>
                                <div className="Campaign-form-row">
                                    <div className="Campaign-form-group">
                                        <label className="input-label">Start Date</label>
                                        <input
                                            type="date"
                                            className="Campaign-input"
                                            value={formData.startDate ? formData.startDate.toISOString().slice(0, 10) : ""}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    startDate: new Date(e.target.value),
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="Campaign-form-group">
                                        <label className="input-label">End Date</label>
                                        <input
                                            type="date"
                                            className="Campaign-input"
                                            value={formData.endDate ? formData.endDate.toISOString().slice(0, 10) : ""}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    endDate: new Date(e.target.value),
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="Campaign-form-group">
                                        <label className="input-label">Status</label>
                                        <select
                                            id="status"
                                            className="Campaign-input"
                                            required
                                            value={formData.status}
                                            onChange={(e) => {
                                                const selectedstatusType = e.target.value;
                                                setFormData((prev) => ({ ...prev, status: selectedstatusType }))
                                            }}
                                        >
                                            <option value='' >Select Status</option>
                                            <option value='Active'>Active</option>
                                            <option value='InActive'>InActive</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="Campaign-form-Row">
                                    <div className="Campaign-form-group">
                                        <label htmlFor="description" className="input-label">
                                            Description
                                        </label>
                                        <textarea
                                            placeholder="Enter description"
                                            className="Campaign-input"
                                            value={formData.description || ""}
                                            onChange={e => {
                                                let value = e.target.value;

                                                // Auto bullet on Enter
                                                if (value.endsWith("\n")) {
                                                    value += "• ";
                                                }
                                                setFormData(prev => ({ ...prev, description: value }));
                                            }}
                                            style={{ height: '100px' }}
                                        />
                                    </div>
                                </div>
                                <div className="Campaign-buttons">
                                    <button className="add-Campaign-button" type="submit" onClick={handleAddCampaign} >
                                        add Campaign
                                    </button>
                                    <button className="cancel-Campaign-button" onClick={() => setIsAddCampaign(false)}>
                                        cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>
                            <div className='Campaign-widgets'>
                                <div className="Campaign-widgets-header">
                                    <h3>Campaigns</h3>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="Campaign-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <div className="add-Camapaign-buttons">

                                    <button className="add-btn-Campaign" onClick={() => setIsAddCampaign(true)}>+ Add New</button>
                                </div>
                            </div>

                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                maxHeight: 400,   // fixed height for table container
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}>
                                <Table className="custom-product-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-product-head">
                                        <TableRow>
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'center',
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: '#e6cf80',
                                                        zIndex: 1,

                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!campaigns || campaigns.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={8}>
                                                    <Typography
                                                        sx={{
                                                            textAlign: 'center',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            padding: '20px',
                                                            fontWeight: 500
                                                        }}
                                                    >
                                                        No campaigns found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            campaigns.map((campaign, index) => (
                                                <TableRow key={campaign._id}>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{limit === "all"
                                                            ? index + 1
                                                            : (currentPage - 1) * Number(limit) + index + 1}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{campaign.campaignName}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{campaign.campaignType}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            {campaign.startDate
                                                                ? DateTime.fromISO(campaign.startDate).toFormat("dd LLL yyyy")
                                                                : "—"}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            {campaign.endDate
                                                                ? DateTime.fromISO(campaign.endDate).toFormat("dd LLL yyyy")
                                                                : "—"}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            {campaign.status}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                            <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                const startDate = campaign.startDate
                                                                    ? new Date(campaign.startDate).toISOString().split("T")[0]
                                                                    : "";
                                                                const endDate = campaign.endDate
                                                                    ? new Date(campaign.endDate).toISOString().split("T")[0]
                                                                    : "";
                                                                setFormData({
                                                                    campaignName: campaign.campaignName || '',
                                                                    campaignType: campaign.campaignType || '',
                                                                    startDate,
                                                                    endDate,
                                                                    status: campaign.status || '',
                                                                    description: campaign.description || '',
                                                                    campaignAssets: campaign.campaignAssets.map(asset => ({
                                                                        _id: asset._id,   // ✅ keep existing ID
                                                                        assetType: asset.assetType,
                                                                        url: asset.url?.toString() || '',
                                                                        file: asset.file || null,
                                                                        description: asset.description
                                                                    })),
                                                                });
                                                                setEditCampaignId(campaign._id);
                                                                setIsPopupMode(true);
                                                                setIsEditMode(true);
                                                            }} />
                                                            <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000' }}
                                                                onClick={() => handleOpen(campaign._id)}
                                                            />
                                                            <div className="tooltip-wrapper"
                                                                onClick={() => navigate(`/sendcampaigns/${campaign._id}`)}
                                                                style={{ cursor: "pointer" }}

                                                            >
                                                                <Icon
                                                                    icon={sendIcon}
                                                                    width={20}
                                                                    height={20}
                                                                    style={{ color: "green", cursor: "pointer" }}
                                                                />
                                                                <span className="tooltip-text">Send Campaign</span>
                                                            </div>
                                                        </Box>

                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>

                                </Table>
                            </TableContainer>
                            <div className="campaign-bottom">
                                <div className="campaign-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="all">All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="campaign-section showing-range">
                                    {
                                        limit === 'all'
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="campaign-section spacer"></div>
                                <div className="campaign-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon
                                            icon={closeIcon}
                                            className="popup-close-icon-outside"
                                            onClick={() => {
                                                setIsPopupMode(false);
                                                setIsEditMode(false);
                                                setFormData({
                                                    campaignName: "",
                                                    campaignType: "",
                                                    description: "",
                                                    campaignAssets: [
                                                        { assetType: "", url: "", file: "", description: "" }
                                                    ],
                                                    startDate: "",
                                                    endDate: "",
                                                    status: ""
                                                });
                                            }}
                                        />
                                        <div className="popup-form">
                                            <h2 className="popup-title">
                                                {isEditMode ? "Edit Campaign" : "Add Campaign"}
                                            </h2>
                                            <form className="popup-form-body" onSubmit={handleUpdateCampaign} >
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="campaignName">Camapaign Name</label>
                                                        <input
                                                            type="text"
                                                            id="campaignName"
                                                            value={formData.campaignName}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    campaignName: e.target.value,
                                                                }))
                                                            }
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="input-label">Campaign Type</label>
                                                        <select
                                                            id="campaignType"
                                                            className="Campaign-input"
                                                            required
                                                            disabled={!formData.campaignName}
                                                            value={formData.campaignType}
                                                            onChange={(e) => {
                                                                const selectedcampaignType = e.target.value;
                                                                setFormData((prev) => ({ ...prev, campaignType: selectedcampaignType }))
                                                            }}
                                                        >
                                                            <option value='' >Select Campaign Type</option>
                                                            <option value='Email'>Email</option>
                                                            <option value='WhatsApp'>WhatsApp</option>
                                                            <option value='SMS'>SMS</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label className="input-label">Start Date</label>
                                                        <input
                                                            type="date"
                                                            className="Campaign-input"
                                                            value={formData.startDate ? formData.startDate.slice(0, 10) : ""}
                                                            onChange={(e) =>
                                                                setFormData({
                                                                    ...formData,
                                                                    startDate: e.target.value, // keep it as "YYYY-MM-DD"
                                                                })
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="input-label">End Date</label>
                                                        <input
                                                            type="date"
                                                            className="Campaign-input"
                                                            value={formData.endDate ? formData.endDate.slice(0, 10) : ""}
                                                            onChange={(e) =>
                                                                setFormData({
                                                                    ...formData,
                                                                    endDate: new Date(e.target.value),
                                                                })
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="input-label">Status</label>
                                                        <select
                                                            id="status"
                                                            className="Campaign-input"
                                                            required
                                                            value={formData.status}
                                                            onChange={(e) => {
                                                                const selectedstatusType = e.target.value;
                                                                setFormData((prev) => ({ ...prev, status: selectedstatusType }))
                                                            }}
                                                        >
                                                            <option value='' >Select Status</option>
                                                            <option value='Active'>Active</option>
                                                            <option value='InActive'>InActive</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="form-group-row-campaignAssets">
                                                    <label className="input-label">Campaign Assets</label>

                                                    {formData.campaignAssets.map((asset, index) => (
                                                        <div key={index} className="asset-block">
                                                            {/* Asset Type */}
                                                            <select
                                                                value={asset.assetType}
                                                                onChange={(e) =>
                                                                    handleAssetChange(index, "assetType", e.target.value)
                                                                }
                                                            >
                                                                <option value="">Select Asset Type</option>
                                                                <option value="Image">Image</option>
                                                                <option value="Video">Video</option>
                                                                <option value="PDF">PDF</option>
                                                                <option value="Link">Link</option>
                                                                <option value="Other">Other</option>
                                                            </select>

                                                            {/* URL or File */}
                                                            {asset.assetType === "Link" ? (
                                                                <input
                                                                    type="url"
                                                                    placeholder="Enter URL"
                                                                    value={asset.url || ""}
                                                                    onChange={(e) =>
                                                                        handleAssetChange(index, "url", e.target.value)
                                                                    }
                                                                />
                                                            ) : asset.assetType === "Image" ||
                                                                asset.assetType === "Video" ||
                                                                asset.assetType === "PDF" ? (
                                                                <>
                                                                    {asset.file && (
                                                                        <a href={asset.url} target="_blank" rel="noreferrer">
                                                                            View Uploaded {asset.assetType}
                                                                        </a>
                                                                    )}
                                                                    <input
                                                                        type="file"
                                                                        accept={
                                                                            asset.assetType === "Image"
                                                                                ? "image/*"
                                                                                : asset.assetType === "Video"
                                                                                    ? "video/*"
                                                                                    : ".pdf"
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleAssetChange(index, "file", e.target.files[0])
                                                                        }
                                                                    />
                                                                </>
                                                            ) : (
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter Asset Info"
                                                                    value={asset.url || ""}
                                                                    onChange={(e) =>
                                                                        handleAssetChange(index, "url", e.target.value)
                                                                    }
                                                                />
                                                            )}

                                                            {/* Description */}
                                                            <input
                                                                type="text"
                                                                placeholder="Description"
                                                                value={asset.description || ""}
                                                                onChange={(e) =>
                                                                    handleAssetChange(index, "description", e.target.value)
                                                                }
                                                            />

                                                            {/* Remove Button */}
                                                            {formData.campaignAssets.length > 1 && (
                                                                <button type="button" onClick={() => removeAsset(index)}>
                                                                    Remove
                                                                </button>
                                                            )}
                                                        </div>
                                                    ))}

                                                    <button type="button" className="add-asset-btn" onClick={addAsset}>
                                                        + Add
                                                    </button>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="description" className="input-label">
                                                            Description
                                                        </label>
                                                        <textarea
                                                            placeholder="Enter description"
                                                            className="Campaign-input"
                                                            value={formData.description || ""}
                                                            onChange={e => {
                                                                let value = e.target.value;

                                                                // Auto bullet on Enter
                                                                if (value.endsWith("\n")) {
                                                                    value += "• ";
                                                                }
                                                                setFormData(prev => ({ ...prev, description: value }));
                                                            }}
                                                            style={{ height: '100px' }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-actions">
                                                    <button type="submit" className="btn-primary">
                                                        {isEditMode ? "Update Camapign" : "Add Camapign"}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn-secondary"
                                                        onClick={() => setIsPopupMode(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {limit > 5 && campaigns.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more campaigns
                                    </Typography>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={modalStyle}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center' }}>
                                        Confirm Delete?
                                    </Typography>
                                    <Typography id="modal-modal-description" sx={{ mt: 1, fontSize: 14, textAlign: 'center' }}>
                                        Are you sure you want to delete this Campaign?
                                    </Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                                        <Button variant="contained" color="error" sx={{ background: 'linear-gradient(#A16A70, #D98484)' }} onClick={handleDeleteCampaign}>
                                            Yes, Delete
                                        </Button>
                                        <Button variant="outlined" color="error" onClick={handleClose} sx={{ background: 'background-color: #D9D9D9', color: '#000' }}>
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                        </>
                    )}
                </main >
            </div >
        </div >
    );
};

export default CampaignPage;